"use strict";
exports.__esModule = true;
exports.GdcExtendedDateFilters = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * @public
 */
var GdcExtendedDateFilters;
(function (GdcExtendedDateFilters) {
    GdcExtendedDateFilters.isDateFilterReference = function (obj) {
        return !isEmpty_1["default"](obj) && !!obj.dateFilterReference;
    };
    GdcExtendedDateFilters.isAttributeFilterReference = function (obj) {
        return !isEmpty_1["default"](obj) && !!obj.attributeFilterReference;
    };
})(GdcExtendedDateFilters = exports.GdcExtendedDateFilters || (exports.GdcExtendedDateFilters = {}));
//# sourceMappingURL=GdcExtendedDateFilters.js.map